import { commitSecureInscan } from "./secureBusinessWrites";

// Keep the existing service signature so the scanner UI and its confirmation
// flow remain unchanged. Authorization and the multi-document transaction now
// run in the trusted Firebase Function.
export function commitInscan({
  barcode,
  partijInfo,
  manualMixOverride = false,
  confirmedInventoryFingerprint = null,
}) {
  return commitSecureInscan({
    barcode,
    partijInfo,
    manualMixOverride,
    confirmedInventoryFingerprint,
  });
}
